module.exports = __webpack_public_path__ + "static/media/BOS 2.0 - User Guide.2cbe64fe.docx";